
import mixins from "vue-typed-mixins";
import { BModal, BIcon } from "bootstrap-vue";
import CustomValidation from "../../mixins/CustomValidation";
import Common from "../../mixins/Common";
import QuestWrapperComponent from "../../components/QuestWrapperComponent.vue";
import store from "@/store";
import { mapGetters, mapMutations } from "vuex";
import { object, string, boolean } from "yup";
import { IReCaptchaVue } from "../../interfaces/IReCaptchaVue";
import { PatientRegisterViewModel } from "@/interfaces/PatientRegisterViewModel";
import { AjaxReturnViewModel } from "@/interfaces/AjaxReturnViewModel";
import { Patient } from "@/interfaces/Patient";
import swal from "sweetalert";
import Password from "primevue/password";
import { ProductRxGroup } from "@/interfaces/ProductRxGroup";
import { AffiliateProductRx } from "@/interfaces/AffiliateProductRx";
import { QuestionnaireProductRx } from "@/interfaces/QuestionnaireProductRx";
import { QuestionnaireViewModel } from "@/interfaces/QuestionnaireViewModel";
import { QuestionnaireTypeProductViewModel } from "@/interfaces/QuestionnaireTypeProductViewModel";
import ProductRxChoice from "../../mixins/ProductRxChoice";
import { TwoFactorTypeEnum } from "@/interfaces/TwoFactorTypeEnum";
import TwoFactorComponent from "@/components/TwoFactorComponent.vue";
import router from "@/router";

enum screen {
  Signin = 0,
  authenticator = 1,
}

export default mixins(CustomValidation, Common, ProductRxChoice).extend({
  name: "SignUpView",
  props: {
    questionnaireType: { type: String, default: null },
  },
  data() {
    return {
      password: "" as string,
      confirmPassword: "" as string,
      firstName: "" as string,
      lastName: "" as string,
      email: "" as string,
      eightChars: false,
      oneNumber: false,
      lowerCase: false,
      upperCase: false,
      match: false,
      enableSubmit: false,
      promoCode: "" as string,
      captchaKey: false,
      iAgree: false,
      lang: "EN",
      twoFactorEnabled: false,
      authenticatorEnabled: false,
      authMethod: 0 as TwoFactorTypeEnum | 0,
      authMethods: [] as TwoFactorTypeEnum | [],
      token: "",
      schema: object().shape({
        password: string().typeError("Password is required.").required("Password is required."),
        confirmPassword: string().typeError("Password is required.").required("Password is required."),
        firstName: string().typeError("First Name is required.").required("First Name is required."),
        lastName: string().typeError("Last Name is required.").required("Last Name is required."),
        email: string().typeError("Email is required").email("The Email field is not a valid e-mail address.").required("Email is required"),
        iAgree: boolean().typeError("You must agree to the terms of use privacy policy and consent to remote health.").oneOf([true], "You must agree to the terms of use privacy policy and consent to remote health.").required("You must agree to the terms of use privacy policy and consent to remote health."),
      }),
      isPasswordShow: false as boolean,
      typedName: "" as string,
      step: 0 as number,
      showSignatureError: false as boolean,
      isConfirmPasswordVisible: false as boolean,
      selectedProductGroups: null as ProductRxGroup[] | null,
      selectedProducts: null as AffiliateProductRx[] | null,
      modalStartTime: null,
      modalEndTime: null,
      timeModalOpen: null,
      view: 0,
    };
  },
  computed: {
    ...mapGetters({
      Content: "getContent",
      QuestType: "getCurrentQuestType",
      QuestionnaireTypeProducts: "getQuestionnaireTypeProducts",
      MarketplaceEstimates: "getMarketplaceEstimates",
      Lang: "getLang",
    }),
    StartBtnTxt(): string {
      if (this.QuestType == 4) {
        return "Sign Up";
      }
      if (this.Content && !this.Content.lang) {
        return this.Content && this.Content.SignUpButtonText ? this.Content.SignUpButtonText : "Begin Visit";
      }
      if (this.Content && this.Content.lang) {
        return this.Content.lang[this.Lang].SignUpButtonText;
      } else return "Sign Up";
    },
    fullName(): string {
      return `${this.firstName} ${this.lastName}`;
    },
    products(): Array<AffiliateProductRx> {
      return this.q.products;
    },
    productGroups(): Array<ProductRxGroup> {
      return this.q.productGroups;
    },
    currentQTP(): QuestionnaireTypeProductViewModel {
      const currentQTP = this.QuestionnaireTypeProducts.filter((x: QuestionnaireTypeProductViewModel) => x.id == this.q.quest.questionnaireTypeID);
      return currentQTP && currentQTP.length && currentQTP[0] ? currentQTP[0] : null;
    },
  },
  watch: {
    password: function () {
      this.validatePassword();
    },
    confirmPassword: function () {
      this.validatePassword();
    },
  },
  created() {
    this.setupValidation(this.schema);
  },
  mounted() {
    if (!this.questionnaireType) {
      router.replace({
        path: "/questionnaire/signup",
        query: { t: this.QuestType },
      });
    }
    this.importData(this.q.quest);
    this.trackTimeOnPage();
    if (this.OTPAuthOnly) {
      this.password = crypto.randomUUID();
    }
  },
  methods: {
    ...mapMutations({
      setLoading: "setLoading",
    }),
    async recaptcha(): Promise<string | null> {
      let token = null;
      try {
        await (this as any as IReCaptchaVue).$recaptchaLoaded();
        (this as any as IReCaptchaVue).$recaptchaInstance.showBadge();
        token = await (this as any as IReCaptchaVue).$recaptcha("login");
        (this as any as IReCaptchaVue).$recaptchaInstance.hideBadge();
      } catch (e) {
        console.log(e);
      }
      return token;
    },
    getDiscountBubble(contentJSON: string) {
      if (contentJSON) {
        return JSON.parse(contentJSON).DiscountBubble;
      }
      return null;
    },
    getStockBubble(contentJSON: string, Lang?: string | null) {
      if (!contentJSON) return null;

      try {
        const content = JSON.parse(contentJSON);

        // If Lang is provided and a matching language image exists, return that
        if (Lang && content.lang && content.lang[Lang] && content.lang[Lang].StockBubble) {
          return content.lang[Lang].StockBubble;
        }

        // Otherwise fallback to the base-level ProductRxImage
        return content.StockBubble || null;
      } catch (e) {
        console.error("Invalid JSON in getProductRxImage:", e);
        return null;
      }
    },
    getPriceOverrideTextHTML(contentJSON: string, Lang?: string | null) {
      if (!contentJSON) return null;

      try {
        const content = JSON.parse(contentJSON);

        // If Lang is provided and a matching language exists, return that
        if (Lang && content.lang && content.lang[Lang] && content.lang[Lang].PriceOverrideText) {
          return content.lang[Lang].PriceOverrideText;
        }

        // Otherwise fallback to the base-level
        return content.PriceOverrideText || null;
      } catch (e) {
        console.error("Invalid JSON in getProductRxImage:", e);
        return null;
      }
    },
    async importData(newVal: QuestionnaireViewModel) {
      if (!newVal) return;
      this.selectedProducts = [];
      this.selectedProductGroups = [];
      var qProductRx = newVal.qProductRxs && newVal.qProductRxs.length > 0 ? newVal.qProductRxs[0] : null;
      for (var i = 0; i < this.productGroups.length; i++) {
        for (var j = 0; j < newVal.qProductRxs.length; j++) {
          if (newVal.qProductRxs[j] && this.productGroups[i].id === newVal.qProductRxs[j].productRxGroupID) {
            this.selectedProductGroups.push(this.productGroups[i]);
          }
        }
      }
      for (i = 0; i < this.products.length; i++) {
        for (j = 0; j < newVal.qProductRxs.length; j++) {
          if (newVal.qProductRxs[j] && this.products[i].id === newVal.qProductRxs[j].productRxID) {
            this.selectedProducts.push(this.products[i]);
          }
        }
      }
      if (this.selectedProducts == null) {
        this.selectedProducts = [] as AffiliateProductRx[];
      }
      if (this.selectedProducts)
        this.setPrxChoices(
          this.q.products.filter((x) => x.isGetStartedProductRx),
          this.selectedProducts[0]
        );
      console.log("DATA PRODUCT GROUPS:", this.selectedProductGroups, "DATA PRODUCTS:", this.selectedProducts);
    },
    getUpdatedData(p: AffiliateProductRx) {
      var q = Object.assign({}, this.q.quest);
      //var qProductRx = q.qProductRxs && q.qProductRxs.length > 0 ? q.qProductRxs[0] : ({} as QuestionnaireProductRx);
      var qProductRx = {} as QuestionnaireProductRx;
      if (q.qProductRxs && q.qProductRxs.length > 0) {
        var qprs = q.qProductRxs.filter((x) => x.productRxGroupID && x.productRxGroupID > 0);
        if (qprs && qprs.length > 0) {
          qProductRx = qprs[0];
        }
      }
      // Save other qprs
      var otherQPRs = q.qProductRxs ? q.qProductRxs.filter((x) => !x.productRxGroupID) : [];

      // Setup main qpr
      qProductRx.productRxID = p.id;
      qProductRx.fillSubscriptionFrequencyDays = this.selectedFrequency ? this.selectedFrequency.fillSubscriptionFrequencyDays : null;
      qProductRx.chargeSubscriptionFrequencyDays = this.selectedFrequency ? this.selectedFrequency.chargeSubscriptionFrequencyDays : null;
      qProductRx.numberOfSubscriptionChargesRequired = this.selectedFrequency ? this.selectedFrequency.numberOfSubscriptionChargesRequired : null;
      qProductRx.isSubscription = this.isSubscription;
      qProductRx.productRxGroupID = p.productRxGroupID;
      qProductRx.active = true;
      q.qProductRxs = [qProductRx];

      // Add other qprs back with same subscription
      otherQPRs.forEach((x) => {
        x.fillSubscriptionFrequencyDays = this.selectedFrequency ? this.selectedFrequency.fillSubscriptionFrequencyDays : null;
        x.chargeSubscriptionFrequencyDays = this.selectedFrequency ? this.selectedFrequency.chargeSubscriptionFrequencyDays : null;
        x.numberOfSubscriptionChargesRequired = this.selectedFrequency ? this.selectedFrequency.numberOfSubscriptionChargesRequired : null;
        x.isSubscription = this.isSubscription;
        q.qProductRxs.push(x);
      });
      console.log("q:", q);
      return q;
    },
    async onSubmitMFA(code: string, method: TwoFactorTypeEnum) {
      this.setLoading(true);
      const response = await store.dispatch("SignInMFA", { c: code, method: method, token: this.token });

      this.setLoading(false);
      if (response == null) {
        if (this.Lang === "ESP") {
          swal("¡Error al iniciar sesión!", "Token de autenticación inválido", "error");
        } else {
          swal("Sign in failed!", "Invalid auth token", "error");
        }
        return;
      }
      if (!response) {
        if (this.Lang === "ESP") {
          swal("¡Error al iniciar sesión!", "Código inválido", "error");
        } else {
          swal("Sign in failed!", "Invalid code", "error");
        }
        return;
      }
      await this.Signin();
    },
    async OnSubmit() {
      this.setLoading(true);
      if (this.$gtm && this.$gtm.enabled() && (this.Content.GTMConfig || this.Content.lang[this.Lang].GTMConfig) && !this.Content.GTMToggleOff) {
        window.dataLayer?.push({
          event: "signup",
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
        });
      }
      const rt = await this.recaptcha();
      if (rt && rt.length > 0) {
        this.errors = [];
        this.schema
          .validate(this, { abortEarly: false })
          .then(async () => {
            this.errors = [];
            let prVM: PatientRegisterViewModel = { questionnaireTypeID: this.QuestType, iAgree: this.iAgree, captchaToken: rt, email: this.email, firstName: this.firstName, lastName: this.lastName, password: this.password, promoCode: this.promoCode, preferredLanguage: this.Lang ?? null };
            let pVM = (await store.dispatch("PatientRegister", prVM)) as AjaxReturnViewModel<Patient>;
            if (!pVM || !pVM.success) {
              this.setLoading(false);
              swal("Error", "Error creating user. If you already have an account a password reset email has been sent. If not, please try again.");
              return;
            }
            var signedIn = await store.dispatch("SignIn", { u: prVM.email, p: prVM.password });
            if (!signedIn) {
              this.setLoading(false);
              swal("Error", "Error signing in. If you already have an account a password reset email has been sent. If not, please try again.");
              return;
            }
            // Leaving this here in case we need it. Flow is still in development
            // if (this.MarketplaceEstimates) {
            //   await this.$store.dispatch("UpdateMarketplaceEstimates", this.MarketplaceEstimates);
            // }
            if (signedIn.twoFactorEnabled) {
              this.twoFactorEnabled = true;
              this.token = signedIn.token;
              this.authMethods = signedIn?.authMethods;
              this.authMethod = this.authMethods?.includes(TwoFactorTypeEnum.App) ? TwoFactorTypeEnum.App : !this.authMethods?.includes(TwoFactorTypeEnum.SMS) ? TwoFactorTypeEnum.Email : TwoFactorTypeEnum.None;
              if (this.authMethods == null) {
                swal("Error", "An error occured while trying to retrieve your account details.");
                return;
              }

              this.view = screen.authenticator;
              return;
            }
            this.Signin();
            await this.$store.dispatch("UpdatePreferredLanguage", this.Lang);
          })
          .catch((err: { inner: any[] }) => {
            this.setLoading(false);
            err.inner.forEach((error: { path: string; message: string }): void => {
              this.errors.push({ key: error.path, value: error.message });
            });
          });
      } else {
        this.setLoading(false);
        swal("Error", "There was an error verifying that you are not a bot. Please refresh the screen and try again.");
      }
    },
    Signin: function () {
      let p = this.selectedProducts && this.selectedProducts.length > 0 && this.selectedProducts[0] ? this.selectedProducts[0] : null;
      let sp = this.prxs && p && p.productRxGroupID ? this.prxs[p.productRxGroupID] : null;
      this.$emit("saveandnavigate", "+", sp ? this.getUpdatedData(sp) : null);
    },
    validatePassword: function () {
      this.enableSubmit = false;

      if (this.password && this.password.length > 7) {
        this.eightChars = true;
      } else {
        this.eightChars = false;
      }
      var rgxON = RegExp("[0-9]");
      if (this.password && rgxON.test(this.password)) {
        this.oneNumber = true;
      } else {
        this.oneNumber = false;
      }
      var lcRGX = RegExp("[a-z]");
      if (this.password && lcRGX.test(this.password)) {
        this.lowerCase = true;
      } else {
        this.lowerCase = false;
      }
      var ucRGX = RegExp("[A-Z]");
      if (this.password && ucRGX.test(this.password)) {
        this.upperCase = true;
      } else {
        this.upperCase = false;
      }
      if (this.isConfirmPasswordVisible) {
        if (this.password && this.confirmPassword && this.password == this.confirmPassword) {
          this.match = true;
        } else {
          this.match = false;
        }
      } else if (!this.isConfirmPasswordVisible && this.password) {
        this.match = true;
        this.confirmPassword = this.password;
      } else {
        this.match = false;
      }
      if (this.eightChars && this.oneNumber && this.lowerCase && this.upperCase && this.match) {
        this.enableSubmit = true;
      }
      if (this.OTPAuthOnly) this.enableSubmit = true;
      console.log("match:", this.match);
    },
    /*getCode: function () {
      if (ed.common.qs["code"] && ed.common.qs["code"].length > 0) {
        this.GetPromoByCode(ed.common.qs["code"], function () {
          $(".form").attr("action", $(".form").attr("action") + "?code=" + ed.common.qs["code"]);
          swal("Oh Yeah!", "Your coupon code (" + this.promoCode + ") will be applied when checking out!", "info");
        });
      }
    },*/
    async GetPromoByCode(code: string | null, cb: () => void, failCB: () => void) {
      if (!code) return;
      const codePromo = await store.dispatch("GetPromoByCode", { t: this.QuestType, code: code, notInitialQuest: false });
      if (codePromo && codePromo.data) {
        this.promoCode = code;
        if (cb) cb();
      } else {
        if (failCB) failCB();
      }
    },
    togglePassword() {
      this.isPasswordShow = !this.isPasswordShow;
    },

    async confirmTerms() {
      if (this.$attrs["confirm-terms"]) {
        this.$bvModal.show("confirm-terms-modal");
        this.step = 0;
      }
    },
    confirmAndClose() {
      if (this.typedName === this.fullName) {
        this.iAgree = true;
        this.step = 1;
        setTimeout(() => {
          this.$bvModal.hide("confirm-terms-modal");
        }, 2000);
      } else {
        this.showSignatureError = true;
      }
    },
    cancelAndClose() {
      this.iAgree = false;
      this.$bvModal.hide("confirm-terms-modal");
    },
    getProductRxImage(contentJSON: string, Lang?: string | null) {
      if (!contentJSON) return null;

      try {
        const content = JSON.parse(contentJSON);

        // If Lang is provided and a matching language image exists, return that
        if (Lang && content.lang && content.lang[Lang] && content.lang[Lang].ProductRxImage) {
          return content.lang[Lang].ProductRxImage;
        }

        // Otherwise fallback to the base-level ProductRxImage
        return content.ProductRxImage || null;
      } catch (e) {
        console.error("Invalid JSON in getProductRxImage:", e);
        return null;
      }
    },
    getDrugNameAlt(contentJSON: string, Lang?: string | null) {
      if (!contentJSON) return null;

      try {
        const content = JSON.parse(contentJSON);

        // If Lang is provided and a matching language image exists, return that
        if (Lang && content.lang && content.lang[Lang] && content.lang[Lang].RxTitleOverride) {
          return content.lang[Lang].RxTitleOverride;
        }

        // Otherwise fallback to the base-level ProductRxImage
        return content.RxTitleOverride || null;
      } catch (e) {
        console.error("Invalid JSON in getProductRxImage:", e);
        return null;
      }
    },
    getBoxIncludes(contentJSON: string, Lang?: string | null) {
      if (!contentJSON) return null;

      try {
        const content = JSON.parse(contentJSON);

        // If Lang is provided and a matching language exists, return that
        if (Lang && content.lang && content.lang[Lang] && content.lang[Lang].BoxIncludes) {
          return content.lang[Lang].BoxIncludes;
        }

        // Otherwise fallback to the base-level BoxIncludes
        return content.BoxIncludes || null;
      } catch (e) {
        console.error("Invalid JSON in getProductRxImage:", e);
        return null;
      }
    },
    getProgramIncludesTitle(contentJSON: string, Lang?: string | null) {
      if (!contentJSON) return null;

      try {
        const content = JSON.parse(contentJSON);

        // If Lang is provided and a matching language exists, return that
        if (Lang && content.lang && content.lang[Lang] && content.lang[Lang].ProgramIncludesTitle) {
          return content.lang[Lang].ProgramIncludesTitle;
        }

        // Otherwise fallback to the base-level ProgramIncludesTitle
        return content.ProgramIncludesTitle || null;
      } catch (e) {
        console.error("Invalid JSON in getProductRxImage:", e);
        return null;
      }
    },
    getProgramAlsoIncludes(contentJSON: string, Lang?: string | null) {
      if (!contentJSON) return null;

      try {
        const content = JSON.parse(contentJSON);

        // If Lang is provided and a matching language exists, return that
        if (Lang && content.lang && content.lang[Lang] && content.lang[Lang].ProgramIncludesV2) {
          return content.lang[Lang].ProgramIncludesV2;
        }

        // Otherwise fallback to the base-level ProgramIncludesV2
        return content.ProgramIncludesV2 || null;
      } catch (e) {
        console.error("Invalid JSON in getProductRxImage:", e);
        return null;
      }
    },
    getProgramIncludes(contentJSON: string, Lang?: string | null) {
      if (!contentJSON) return null;

      try {
        const content = JSON.parse(contentJSON);

        // If Lang is provided and a matching language exists, return that
        if (Lang && content.lang && content.lang[Lang] && content.lang[Lang].ProgramIncludes) {
          return content.lang[Lang].ProgramIncludes;
        }

        // Otherwise fallback to the base-level ProgramIncludes
        return content.ProgramIncludes || null;
      } catch (e) {
        console.error("Invalid JSON in getProductRxImage:", e);
        return null;
      }
    },
    getPricePerMonth(contentJSON: string, Lang?: string | null) {
      if (!contentJSON) return null;

      try {
        const content = JSON.parse(contentJSON);

        // If Lang is provided and a matching language image exists, return that
        if (Lang && content.lang && content.lang[Lang] && content.lang[Lang].PricePer) {
          return content.lang[Lang].PricePer;
        }

        // Otherwise fallback to the base-level PricePer
        return content.PricePer || null;
      } catch (e) {
        console.error("Invalid JSON in getProductRxImage:", e);
        return null;
      }
    },
    getComparedPrice(contentJSON: string) {
      if (contentJSON) {
        return JSON.parse(contentJSON).ComparedPrice;
      }
      return null;
    },
    getTotalSavings(contentJSON: string) {
      if (contentJSON) {
        return JSON.parse(contentJSON).TotalSavings;
      }
      return null;
    },
    openWelcomeModal() {
      this.$bvModal.show("welcome-message");
      this.modalStartTime = performance.now();
      setTimeout(() => {
        this.modalClickListener();
      }, 1000);
    },
    trackTimeOnPage() {
      if (this.Content && this.Content.SignUpModalContent) {
        setTimeout(() => {
          this.openWelcomeModal();
        }, this.Content.WelcomeModalTimer);
      }
    },
    modalClickListener() {
      const button = document.getElementById("close-modal");
      if (button) {
        button.addEventListener("click", () => {
          this.$bvModal.hide("welcome-message");
          this.modalEndTime = performance.now();
          this.timeModalOpen = Math.round(((this.modalEndTime - this.modalStartTime) / 1000) * 10) / 10;
          console.log(this.modalEndTime, this.modalStartTime);
          console.log("Open Modal", this.timeModalOpen);
        });
      }
    },
  },
  components: { QuestWrapperComponent, BModal, Password, TwoFactorComponent },
});
